const productIdElement = document.getElementById("timelogapp-product-id")
const trackerIdElement = document.getElementById("timelogapp-tracker-id")
const trackerSpeedFactorElement = document.getElementById("timelogapp-tracker-speed-factor")
const trackerDistanceFactorElement = document.getElementById("timelogapp-tracker-distance-factor")
const expenseFormTypeElement = document.getElementById("timelogapp-expense-form-type")
const expenseFormListElement = document.getElementById("timelogapp-expense-form-list")
const productId = productIdElement ? productIdElement.value : null
const trackerId = trackerIdElement ? trackerIdElement.value : null
const expenseFormType = expenseFormTypeElement ? expenseFormTypeElement.value : null;
const expenseFormList = expenseFormListElement ? expenseFormListElement.value : null;
const trackerSpeedFactor = trackerSpeedFactorElement ? trackerSpeedFactorElement.value : 1;
const trackerDistanceFactor = trackerDistanceFactorElement ? trackerDistanceFactorElement.value : 1;
const wpLocalized = window["wpLocalizedObject"] || {}

export default {
    productId: productId,
    trackerId: trackerId || "",
    nonce: wpLocalized.rest_nonce,
    expenseFormType: expenseFormType,
    expenseFormList: expenseFormList,
    trackerDistanceFactor: trackerDistanceFactor,
    trackerSpeedFactor: trackerSpeedFactor,
    url: wpLocalized.rest_url || "",
    ui_units_speed: wpLocalized.ui_units_speed,
    ui_units_distance: wpLocalized.ui_units_distance,
    gps_api_url: wpLocalized.gps_api_url || "",
    gps_api_key: wpLocalized.gps_api_key || "",
    login_url: wpLocalized.login_url || ""
}